// extracted by mini-css-extract-plugin
module.exports = {"notificationHeader":"_3eSWiIH","ngNotif":"_1Zw0zDh","large":"_34mpcDY"};